<template>
  <div class="privacy">
    <h2>个人信息处理</h2>
    <h4>尊敬的访问者：</h4>
    <p>衷心欢迎您访问丘比粉丝俱乐部。</p>
    <p>
      根据《中华人民共和国个人信息保护法》等相关法律法规（以下称“个人信息保护法规”）的规定，我们作为个人信息的处理者，在处理您的个人信息前，将依法履行个人信息保护法规规定的各项公示和告知义务并取得您对相关事项的同意。为了维护您作为个人信息提供者的合法权益，请您详细阅读以下内容。
    </p>
    <p class="fontBold">
      当您按下下面的“同意”按钮时，即表示您已经完成了以下工作并作出了相关的同意我们处理您的个人信息的意思表示。
    </p>
    <p>
      （1）您已经详细阅读并理解了我们向您公示的《隐私保护政策》的全部内容。《隐私保护政策》您可以通过点击本公众号内的“爱在丘比”-“隐私保护”获得。
    </p>
    <p>
      （2）当您通过点击“丘比粉丝俱乐部”中的“我”-“完善个人资料得140积分”并填写个人资料（以下称“附加个人信息”）时，表示您同意自愿向我们提供该信息并同意我们将该信息用于下述第
    </p>
    <p>（3）项的处理目的。</p>
    <p class="fontBold">1）真实姓名 *</p>
    <p class="fontBold">2）性别</p>
    <p class="fontBold">3）手机号码 *</p>
    <p class="fontBold">4）所在省市区 *</p>
    <p class="fontBold">5）邮寄地址 *</p>
    <p class="fontBold">6）邮箱 （ * 6）-8）可择一提供）</p>
    <p class="fontBold">7）qq号 （ * 6）-8）可择一提供）</p>
    <p class="fontBold">8）微信号 （ * 6）-8）可择一提供）</p>
    <p>
      您仍有权拒绝提供或撤回您已经提供的上述信息，或有关对于我们处理您个人信息的同意，但当您拒绝提供标注*符号的个人信息时，您将无法获得我们提供的140积分。同时，我们也将无法在您满足积分兑换奖励条件时，向您寄送相关奖品并为此与您取得必要的联系。由于您提供的附加个人信息不准确或存在错误，也将可能造成我们无法向您提供上述产品和服务。对此，我们将无需承担相应责任。
    </p>
    <p>（3）您同意我们将您的附加个人信息用于以下目的：</p>
    <p class="fontBold">
      1）用于我们进一步实施对于访问丘比粉丝俱乐部人群的分析、统计和管理，以提升服务质量进而提升客户满意度；
    </p>
    <p class="fontBold">
      2）当您满足积分兑换奖励条件时，向您寄送相关奖品并为此与您取得必要的联系，进行确认；
    </p>
    <p>（4）委托处理附加个人信息的受托人</p>
    <p>
      由于本公众号由我公司（北京丘比食品有限公司）委托<span class="fontBold"
        >大广（中国）广告有限公司北京分公司</span
      >（以下称“受托人”）制作并维护。因此，您所提供的信息，将由我公司委托受托人进行信息处理、保存和管理。您同意由受托人处理您的信息。
      受托人的详细信息如下：
    </p>
    <h5 style="margin-top: 10px">
      公司名称：大广（中国）广告有限公司北京分公司
    </h5>
    <h5>联系方式：010-65889255</h5>
    <h5>
      处理目的：辅助我公司实现本规则第二条中的“所收集的个人信息的使用目的”
    </h5>
    <h5>
      处理方式：对于个人信息进行收集、存储，应北京丘比食品有限公司的要求向其进行提供
    </h5>
    <h5>个人信息的种类：您所提供的信息</h5>
    <div class="agree-btn" @click="agreeClick">同意</div>
  </div>
</template>
<script>
export default {
  name: "Privacy",
  components: {},
  props: {
    // props: {
    //   type: String
    // }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    agreeClick() {
      this.$router.push({ path: "/edit" });
    },
  },
  watch: {},
};
</script>
<style scoped>
.privacy {
  padding: 20px;
  background: #fff;
}
.privacy h2 {
  margin-bottom: 10px;
  text-align: center;
}
.privacy p {
  margin-top: 5px;
  text-indent: 2em;
  font-size: 14px;
  color: #707070;
}
.privacy .fontBold {
  font-weight: bold;
  color: #232323;
}
.agree-btn {
  margin: 20px;
  padding: 10px 0;
  text-align: center;
  border-radius: 5px;
  font-size: 15px;
  color: #fff;
  background-color: var(--color-main);
}
</style>